var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oAuthAuthorizer"},[_c('img',{staticClass:"loader",attrs:{"src":require('@/assets/loader.gif'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }